import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../../../../backend/firebaseConfig";

export const getIODetailsRef = (adviserEmail) =>
  doc(
    db,
    "Authorized Members",
    "Advisers",
    "Data",
    adviserEmail,
    "IO Details",
    "Data",
  );

export const getLegacyIDDetailsRef = (adviserEmail) =>
  doc(
    db,
    "Authorized Members",
    "Advisers",
    "Data",
    adviserEmail,
    "ID Details",
    "Data",
  );

export const subscribeIODetails = (adviserEmail, onValue, onError) => {
  if (!adviserEmail || adviserEmail === "-") {
    onValue?.({});
    return () => {};
  }

  return onSnapshot(
    getIODetailsRef(adviserEmail),
    (snapshot) => onValue?.(snapshot.exists() ? snapshot.data() : {}),
    onError,
  );
};

const saveDetails = async (detailsRef, adviserEmail, details) => {
  const currentSnapshot = await getDoc(detailsRef);
  const previousDetails = currentSnapshot.exists()
    ? currentSnapshot.data()
    : {};
  const changes = Object.entries(details)
    .map(([fieldPath, newValue]) => {
      const previousValue = previousDetails[fieldPath] ?? "";
      return String(previousValue) === String(newValue)
        ? null
        : { fieldPath, previousValue, newValue };
    })
    .filter(Boolean);
  const updatedBy = auth.currentUser?.email || "";
  const updatedByName =
    auth.currentUser?.displayName || updatedBy || "Unknown user";

  await setDoc(
    detailsRef,
    {
      ...details,
      updatedAt: serverTimestamp(),
      updatedBy,
      updatedByName,
    },
    { merge: true },
  );

  if (changes.length > 0) {
    await addDoc(collection(detailsRef, "Edit Logs"), {
      adviserEmail,
      changes,
      changeCount: changes.length,
      updatedAt: serverTimestamp(),
      updatedBy,
      updatedByName,
      editedAt: serverTimestamp(),
      editedBy: updatedBy,
    });
  }
};

export const saveIODetails = async (adviserEmail, ioDetails) => {
  if (!adviserEmail || adviserEmail === "-") {
    throw new Error("Adviser email not found.");
  }

  await saveDetails(getIODetailsRef(adviserEmail), adviserEmail, ioDetails);
};
